import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Index",
    component: () => import("@/views/Index.vue"),
    children: [
      {
        name: "EmailVerified",
        path: "email-verified/:token",
        component: () => import("@/views/EmailVerified.vue")
      },
      {
        name: "ResetPin",
        path: "reset-pin/:token",
        component: () => import("@/views/ResetPin.vue")
      },
      {
        name: "NotFound",
        path: "not-found",
        component: () => import("@/views/NotFound.vue")
      },
      {
        name: "About",
        path: "/about",
        component: () => import("@/views/About.vue")
      },
      {
        name: "SEmailVerified",
        path: "staging/email-verified/:token",
        component: () => import("@/views/staging/SEmailVerified.vue")
      },
      {
        name: "SResetPin",
        path: "staging/reset-pin/:token",
        component: () => import("@/views/staging/SResetPin.vue")
      },
      {
        name: "DeepLink",
        path: "/deeplink-test",
        component: () => import("@/views/DeeplinkTest.vue")
      }
    ]
  }
];

const router = new VueRouter({
  routes,
  mode: "history"
});

export default router;
